<template>
  <div v-if="filterPage" class="body-max-width filter-page">
    <div class="filter-header">
      <button @click="showFilter" class="filter-close">
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.701286 0.701286C1.10297 0.299604 1.75422 0.299604 2.15591 0.701286L7.60002 6.1454L13.0441 0.701286C13.4458 0.299604 14.0971 0.299604 14.4988 0.701286C14.9004 1.10297 14.9004 1.75422 14.4988 2.15591L9.05464 7.60002L14.4988 13.0441C14.9004 13.4458 14.9004 14.0971 14.4988 14.4988C14.0971 14.9004 13.4458 14.9004 13.0441 14.4988L7.60002 9.05464L2.15591 14.4988C1.75422 14.9004 1.10297 14.9004 0.701286 14.4988C0.299604 14.0971 0.299604 13.4458 0.701286 13.0441L6.1454 7.60002L0.701286 2.15591C0.299604 1.75422 0.299604 1.10297 0.701286 0.701286Z"
            fill="#037968"
          />
        </svg>
      </button>
      <p class="header flex-mid">{{ $t("filter") }}</p>
      <p class="filter-clear" @click="clearFilter()">{{ $t("clearFilter") }}</p>
    </div>
    <div class="body-max-width filter-part">
      <p class="category-header">{{ $t("filterCategory") }}</p>
      <select v-model="selectCategory" class="filter-category">
        <option value="" disabled selected>{{ $t("filterBy") }}</option>
        <option
          v-for="category in categoryList"
          :value="category.categoryId"
          :key="category.id"
        >
          {{ category.categoryName }}
        </option>
      </select>
    </div>
    <div class="filter-nav flex-mid">
      <button class="filter-confirm" @click="applyFilter()">
        {{ $t("confirm") }}
      </button>
    </div>
  </div>

  <div v-else class="body-max-width-no-padding">
    <div class="green-background">
      <div class="body-max-width">
        <Header back="/home" :title="$t('findPackage')"></Header>
        <div class="body-max-width">
          <div class="select-branch">
            <div class="icon flex-mid">
              <svg
                width="21"
                height="24"
                viewBox="0 0 21 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.212 4.72034C16.9622 5.45969 17.5574 6.33747 17.9634 7.30358C18.3695 8.26967 18.5784 9.30516 18.5784 10.3509C18.5784 11.3966 18.3695 12.4321 17.9634 13.3982C17.5574 14.3643 16.9622 15.2421 16.212 15.9814L10.5 21.6088L4.788 15.9798C4.03789 15.2405 3.44287 14.3626 3.03692 13.3965C2.63096 12.4304 2.42201 11.395 2.42201 10.3493C2.42201 9.3036 2.63096 8.26816 3.03692 7.30206C3.44287 6.33597 4.03789 5.45816 4.788 4.71875C5.53812 3.97933 6.42863 3.3928 7.40868 2.99263C8.38875 2.59246 9.43919 2.3865 10.5 2.3865C11.5608 2.3865 12.6112 2.59246 13.5913 2.99263C14.5714 3.3928 15.4618 3.97933 16.212 4.71875V4.72034ZM17.9243 17.6693C19.3928 16.2219 20.3929 14.3776 20.7982 12.3698C21.2034 10.362 20.9955 8.2809 20.2009 6.38959C19.4061 4.49827 18.0603 2.88174 16.3336 1.74439C14.6068 0.607054 12.5767 0 10.5 0C8.42326 0 6.39316 0.607054 4.66642 1.74439C2.93969 2.88174 1.59388 4.49827 0.799179 6.38959C0.00449056 8.2809 -0.203393 10.362 0.201826 12.3698C0.607045 14.3776 1.60716 16.2219 3.07569 17.6693L8.78607 23.2998C9.0111 23.5218 9.27828 23.6979 9.57238 23.818C9.86646 23.9382 10.1817 24 10.5 24C10.8183 24 11.1336 23.9382 11.4276 23.818C11.7217 23.6979 11.9889 23.5218 12.2139 23.2998L17.9243 17.6693ZM10.5 13.5356C11.3569 13.5356 12.1786 13.2 12.7845 12.6028C13.3904 12.0056 13.7308 11.1955 13.7308 10.3509C13.7308 9.50624 13.3904 8.69621 12.7845 8.09896C12.1786 7.50171 11.3569 7.16619 10.5 7.16619C9.64315 7.16619 8.82139 7.50171 8.2155 8.09896C7.60962 8.69621 7.26923 9.50624 7.26923 10.3509C7.26923 11.1955 7.60962 12.0056 8.2155 12.6028C8.82139 13.2 9.64315 13.5356 10.5 13.5356Z"
                  fill="#337375"
                />
              </svg>
            </div>
            <div>
              <p class="branch">{{ $t("branch") }}</p>
              <div class="selection">
                <select
                  class="select-hospital"
                  id="selectHospital"
                  v-model="selectHospital"
                  :placeholder="$t('choosehospital')"
                  @change="getPackage()"
                >
                  <option :label="$t('sukhumvit')" value="1"></option>
                  <option :label="$t('srinakarin')" value="2"></option>
                  <option :label="$t('thonburi')" value="4"></option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="body-max-width flex-mid search-box">
      <input
        :placeholder="$t('seacrhPlaceHolder')"
        v-model="searchPackage"
        type="text"
      />
      <button class="search-btn flex-mid" @click="searchData()">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_561_4144)">
            <path
              d="M12.8335 12.8335L9.13281 9.13281"
              stroke="#FCFCFD"
              stroke-width="2"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5.83341 10.5001C8.41074 10.5001 10.5001 8.41074 10.5001 5.83341C10.5001 3.25609 8.41074 1.16675 5.83341 1.16675C3.25609 1.16675 1.16675 3.25609 1.16675 5.83341C1.16675 8.41074 3.25609 10.5001 5.83341 10.5001Z"
              stroke="#FCFCFD"
              stroke-width="2"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_561_4144">
              <rect width="14" height="14" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </button>
    </div>

    <div class="body-max-width filter-group">
      <div
        v-if="showDefaultCategory"
        class="filter-show-category-2"
        @click="showFilter()"
      >
        <p class="show-category-2">{{ $t("filterCategory") }}</p>
        <img src="@/assets/image/NewDesign/sliders.svg" />
      </div>
      <div v-else class="filter-show-category" @click="showFilter()">
        <p class="show-category">{{ showCategory }}</p>
      </div>

      <!-- <select v-model="selectCategory" class="filter-category">
        <option v-for="category in categoryList" :value="category.categoryId" :key="category.id">
          {{ category.categoryName }}
        </option>
      </select> -->

      <select class="filter-type" v-model="selectSort">
        <option value="" disabled selected>{{ $t("sortBy") }}</option>
        <option :value="1" :label="$t('recentlyFilter')"></option>
        <option :value="2" :label="$t('recommendFilter')"></option>
      </select>
    </div>

    <hr class="seperate-line" />
    <div class="body-max-width">
      <p v-if="keyword == ''" class="package-header">
        {{ $t("allPackage") }}&nbsp;{{ "(" }} {{ packageLength }} {{ ")" }}
      </p>
      <p v-else class="package-header">
        {{ keyword }}&nbsp;{{ "(" }} {{ packageLength }} {{ ")" }}
      </p>
    </div>

    <div
      v-if="packageData.length == 0"
      style="text-align: center; font-size: 2rem; padding-top: 10rem"
      class="body-max-width"
    >
      {{ $t("notFound") }}
    </div>

    <div class="package-card-container mt-20 body-max-width">
      <div
        v-for="value in packageData"
        :key="value.id"
        class="package-card-show"
        id="packageCard"
      >
        <div class="content" @click="showDetail(value)">
          <img class="image" :src="value.imageUrl" :alt="value.packageId" />
          <div class="text">
            <div class="package-name" style="text-overflow: ellipsis">
              {{ value.packageName }}
            </div>
            <hr width="100%" style="border: 0.5px solid #cceab5" />
            <div class="box-below">
              <div
                v-if="value.netPrice == value.fullPrice"
                class="package-price"
              >
                <div class="net-price-2">
                  {{ "฿" + numberWithCommasLine(value.netPrice) }}
                </div>
              </div>
              <div v-else class="package-price">
                <div class="net-price">
                  {{ "฿" + numberWithCommasLine(value.netPrice) }}
                </div>
                <div class="list-price">
                  {{ "฿" + numberWithCommasLine(value.fullPrice) }}
                </div>
              </div>
              <div>
                <button class="booking-button" @click="bookPackage(value)">
                  {{ $t("checkout") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="selectMorePackage" class="more-detail-footer">
      <div class="close" id="close-more-detail-modal" @click="closeModal">
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.364835 0.396198C0.598732 0.163084 0.915812 0.0321447 1.2464 0.0321447C1.57699 0.0321447 1.89405 0.163084 2.12796 0.396198L7.48388 5.74064L12.8398 0.396198C12.9541 0.27389 13.0918 0.175797 13.2448 0.107764C13.3978 0.03973 13.563 0.00314873 13.7305 0.000194351C13.898 -0.00276003 14.0643 0.0279955 14.2197 0.0906018C14.3751 0.153208 14.5161 0.246387 14.6345 0.364595C14.7531 0.482804 14.8464 0.623619 14.9091 0.778607C14.9719 0.933613 15.0028 1.09964 14.9998 1.26678C14.9968 1.43393 14.9602 1.59876 14.892 1.75146C14.8238 1.90416 14.7255 2.04159 14.6029 2.15555L9.24701 7.49999L14.6029 12.8444C14.7255 12.9585 14.8238 13.0959 14.892 13.2486C14.9602 13.4013 14.9968 13.5661 14.9998 13.7332C15.0028 13.9004 14.9719 14.0663 14.9091 14.2214C14.8464 14.3764 14.7531 14.5171 14.6345 14.6353C14.5161 14.7537 14.3751 14.8468 14.2197 14.9093C14.0643 14.9719 13.898 15.0028 13.7305 14.9998C13.563 14.9968 13.3978 14.9603 13.2448 14.8922C13.0918 14.8242 12.9541 14.7261 12.8398 14.6038L7.48388 9.25934L2.12796 14.6038C1.89147 14.8237 1.57868 14.9434 1.2555 14.9377C0.932312 14.9319 0.623965 14.8013 0.39539 14.5732C0.166832 14.3452 0.0359114 14.0375 0.0302062 13.715C0.024501 13.3925 0.144477 13.0805 0.364835 12.8444L5.72075 7.49999L0.364835 2.15555C0.13122 1.92215 0 1.60575 0 1.27587C0 0.945994 0.13122 0.62961 0.364835 0.396198Z"
            fill="#AAAAAA"
          />
        </svg>
      </div>
      <div class="more-detail-box">
        <div class="more-detail-header">
          <img :src="showMore.imageUrl" class="header-img" />
          <div class="header-text">
            <p>{{ showMore.packageName }}</p>
            <div v-if="showMore.netPrice != showMore.fullPrice" class="price">
              <p class="net-price">
                {{ "฿" + numberWithCommasLine(showMore.netPrice) }}
              </p>
              <p class="list-price">
                {{ "฿" + numberWithCommasLine(showMore.fullPrice) }}
              </p>
            </div>
            <div v-else class="price">
              <p class="net-price2">
                {{ "฿" + numberWithCommasLine(showMore.netPrice) }}
              </p>
            </div>
          </div>
        </div>
        <div class="more-detail-item" v-if="showMore.itemList != null">
          <div
            v-for="item in showMore.itemList"
            :key="item.itemid"
            class="more-detail-itemname"
          >
            <ul>
              <li>
                <p v-for="name in item.itemName" :key="name.id">{{ name }}</p>
              </li>
            </ul>
          </div>
        </div>
        <div
          v-for="desc in showMore.packageDescription"
          :key="desc.id"
          class="more-detail-description"
        >
          <p class="more-description">{{ desc }}</p>
        </div>
      </div>
      <button class="booking-button" @click="bookPackage(showMore)">
        {{ $t("confirmCheckout") }}
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Header from "@/components/HomeNav.vue";
import axios from "axios";
import * as config from "@/assets/js/config.js";
var AmazonCognitoIdentity = require("amazon-cognito-identity-js");

export default defineComponent({
  name: "showAllPackage",
  components: {
    Header,
  },
  data() {
    return {
      searchPackage: "",
      accessToken: null,
      error: null,
      lang: "th",
      allPackageList: [],
      packageList: [],
      packageData: [],
      originalPackageData: [],
      sortedPackageData: [],
      categoryList: [],
      selectHospital: 1,
      selectCategory: "",
      categoryId: null,
      genderFilter: "A",
      keyword: "",
      selectSort: "",
      filterPage: false,
      showCategory: "",
      showDefaultCategory: false,
      showMore: [],
      selectMorePackage: false,
      packageLength: 0,
      recommendBy: "",
    };
  },
  watch: {
    searchPackage() {
      if (this.searchPackage == "") {
        this.keyword = this.searchPackage;
        this.categoryId = this.selectCategory;
        this.getPackage();
      }
    },
    selectCategory() {
      this.keyword = this.searchPackage;
      this.categoryId = this.selectCategory;
      this.getPackage();
    },
    selectSort() {
      // Recently
      if (this.selectSort == 1) {
        this.packageData = this.sortedPackageData;
      } else {
        // Recommend
        this.packageData = this.originalPackageData;
      }
    },
  },
  mounted() {
    scrollTo(0, 0);
    this.accessToken = this.$cookies.get("access_token");
    this.lang = this.$cookies.get("lang");
    // this.selectHospital = window.localStorage.getItem("selectHospital")
    //   ? window.localStorage.getItem("selectHospital")
    //   : 1;
    this.selectHospital = this.$route.query.hospitalId
      ? this.$route.query.hospitalId
      : 1;
    this.categoryId = this.$route.query.categoryId
      ? this.$route.query.categoryId
      : "all";
    this.keyword = this.$route.query.keyword ? this.$route.query.keyword : "";
    this.searchPackage = this.keyword;
    if (!this.$route.query.categoryId) {
      this.showDefaultCategory = true;
    }
    this.selectCategory = this.categoryId;
    this.selectHospital = this.$route.query.hospitalId
      ? this.$route.query.hospitalId
      : 1;

    this.genderFilter = this.$cookies.get("gender");
    this.getPackage();
    this.getCategoryList();
  },
  methods: {
    numberWithCommasLine(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ".-";
    },
    searchData() {
      this.keyword = this.searchPackage;
      this.categoryId = this.selectCategory;
      this.getPackage();
    },
    bookPackage(value) {
      // this.$router.push({
      //   path: "/booking",
      //   query: { packageId: value.packageId, hospitalId: value.hospitalId },
      // });
      const selectPackages = [];
      selectPackages.push(value.packageId);
      window.localStorage.setItem("selectHospital", this.selectHospital);
      // this.$store.state.selectedPackageList;
      // set data in store
      this.$store.commit("setSelectedHospital", this.selectHospital);
      this.$store.commit("setSelectedPackageList", selectPackages);
      this.$router.push({
        name: "Booking",
        params: {
          hospitalId: this.selectHospital,
          packageId: JSON.stringify(selectPackages),
        },
      });
    },
    showFilter() {
      if (this.selectCategory == "all" || this.selectCategory == null) {
        this.selectCategory = "";
      }
      this.filterPage = this.filterPage ? false : true;
    },
    clearFilter() {
      this.selectCategory = "all";
      this.keyword = "";
      this.searchPackage = "";
      this.showDefaultCategory = true;
    },
    applyFilter() {
      this.categoryId = this.selectCategory;
      this.filterPage = false;
      let index = this.categoryList.findIndex(
        (category) => category.categoryId == this.categoryId
      );
      this.showCategory = this.categoryList[index].categoryName;
      this.showDefaultCategory = false;
      if (this.selectCategory == "all") {
        this.showDefaultCategory = true;
      }

      this.getPackage();
    },
    getCategoryList() {
      axios
        .get(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/hospital-package/get-package-categories",

          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((res) => {
          let category = res.data;
          if (this.lang == "th") {
            category.push({
              categoryId: "all",
              categoryName: "ดูทั้งหมด",
            });
          } else {
            category.push({
              categoryId: "all",
              categoryName: "All",
            });
          }

          this.categoryList = category;
          let index = this.categoryList.findIndex(
            (category) => category.categoryId == this.categoryId
          );

          this.showCategory = this.categoryList[index].categoryName;
        })
        .catch((error) => {
          if (error.res.status == 403) {
            this.getNewToken();
          } else {
            this.error = error;
            window.$("#errorModal").modal("show");
          }
        });
    },
    closeModal() {
      this.selectMorePackage = false;
    },
    showDetail(data) {
      this.selectMorePackage = true;
      this.showMore = data;
    },
    filterPackage() {
      let filterPackage = this.allPackageList.filter(
        (apackage) =>
          (
            apackage.packageName +
            " " +
            apackage.categoryName +
            " " +
            apackage.hospitalName +
            " " +
            apackage.packageDescription
          )
            .toLowerCase()
            .indexOf(this.searchPackage.toLowerCase()) >= 0
      );
      this.packageList = filterPackage;
    },
    getPackage() {
      if (this.categoryId == "all") {
        this.categoryId = "";
      }
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/hospital-package/get-packages",
          {
            hospitalPackageBean: {
              hospitalId: this.selectHospital,
              categoryId: this.categoryId,
              genderFilter: this.genderFilter,
              keyword: this.keyword,
              enablePackagePrioritySorting: true,
              enableCategoryPrioritySorting: true,
              recommendBy: "ALL",
            },
          },
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((res) => {
          const hospitalId = res.data.hospitalPackageBean.hospitalId;
          const result = res.data.hospitalPackageBean;
          const returnPackage = result.hospitalPackages;
          let healthPackage = [];
          const checkPackage = [];

          returnPackage.forEach((item) => {
            checkPackage.push({
              packageId: item.packageId,
              packageName: item.packageInformation.packageName,
              packageDescription:
                item.packageInformation.packageDescription != null
                  ? item.packageInformation.packageDescription.split("\n")
                  : item.packageInformation.packageDescription,
              fullPrice: item.packageInformation.fullPrice,
              netPrice: item.packageInformation.netPrice,
              imageUrl: item.packageInformation.imageUrl,
              intervalDays: item.packageInformation.intervalDays,
              practitionerId: item.packageInformation.practitionerId,
              packageCode: item.packageInformation.packageCode,
              showPack: false,
              hospitalPackageId: item.hospitalPackageId,
              itemList: item.itemInformation,
              recModifiedWhen: item.recModifiedWhen,
              recCreatedWhen: item.recCreatedWhen,
              priority: item.packageInformation.priority,
              hospitalId: hospitalId,
            });

            for (let i = 0; i < checkPackage.length; i++) {
              for (let j = 0; j < checkPackage[i].itemList.length; j++) {
                checkPackage[i].itemList[j].itemName =
                  checkPackage[i].itemList[j].name.split("\n");
              }
            }
            healthPackage = checkPackage;
          });

          // if (this.selectSort == 1) {
          //   healthPackage.sort((a, b) => {
          //     return a.priority - b.priority
          //   });
          // }
          // else{
          //   healthPackage.sort((a, b) => {
          //     return new Date(b.recModifiedWhen) - new Date(a.recModifiedWhen);
          //   });
          // }
          healthPackage.sort((a, b) => {
            return a.packageId - b.packageId;
          });
          let originalData = JSON.parse(JSON.stringify(healthPackage));
          let sortedData = JSON.parse(JSON.stringify(healthPackage));
          this.packageData = healthPackage;

          // this.sortedPackageData = sortedData.sort((a, b) => {
          //   return new Date(b.recModifiedWhen) - new Date(a.recModifiedWhen);
          // });
          this.sortedPackageData = sortedData.sort((a, b) => {
            const dateDifference =
              new Date(b.recModifiedWhen) - new Date(a.recModifiedWhen);

            if (dateDifference === 0) {
              return b.packageId - a.packageId; // Assuming packageId is a number
            } else {
              return dateDifference;
            }
          });
          this.originalPackageData = originalData.sort((a, b) => {
            return a.priority - b.priority;
          });

          if (this.selectSort == 1) {
            this.packageData = this.sortedPackageData;
          } else {
            this.packageData = this.originalPackageData;
          }
          this.packageLength = this.packageData.length;
        })
        .catch((error) => {
          console.log("error", error);
          if (error.res.status == 403) {
            this.getNewToken();
          } else {
            this.error = error;
            window.$("#errorModal").modal("show");
          }
        });
    },
    groupBy(xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    getNewToken() {
      var refreshToken = this.$cookies.get("refresh_token");
      var token = new AmazonCognitoIdentity.CognitoRefreshToken({
        RefreshToken: refreshToken,
      });

      this.$store.state.userPool = new AmazonCognitoIdentity.CognitoUserPool(
        config.poolData
      );
      const cognitoUser = this.$store.state.userPool.getCurrentUser();
      cognitoUser.refreshSession(token, (err, session) => {
        this.accessToken = session.getIdToken().getJwtToken();
        this.$cookies.set("access_token", this.accessToken);
        this.$cookies.set(
          "refresh_token",
          session.getRefreshToken().getToken()
        );
        window.location.reload();
      });
    },
  },
});
</script>
<style lang="scss" scoped>
.green-background {
  background: #ecf5ca;

  // padding-bottom: 5rem;
  .select-branch {
    display: grid;
    grid-template-columns: 10% auto;
    gap: 1rem;
    margin-top: 2rem;
    margin-bottom: 5rem;
    padding-bottom: 5rem;

    .icon {
    }

    .branch {
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: left;
      margin-bottom: 0rem;
    }

    .selection {
      display: flex;

      .select-hospital {
        font-size: 1.8rem;
        font-weight: 500;
        color: #337375;
        height: 4.1rem;
        width: 90%;
        background: transparent;
        background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAHCAYAAADebrddAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACaSURBVHgBdY2xDYMwEEXvbCTaZIJU2SFllC5dVvAIKZFIZMQAWYENkiqiQ+xB4RFoKcxxBhlZRvzm7t//eofAupfll8cB9tWn1qpkXpFaIPjsVhGeP6179H6h02PTQ1H981y5Xfije8MEExHNKGXh7Vp2b4hQhV3n6yxbATIMu6Yx59v1yMgLARX1612FeQKRUkt6kOLERR1nE6iuMDbwTvnwAAAAAElFTkSuQmCC")
          no-repeat 95% 50%;
        -moz-appearance: none;
        -webkit-appearance: none;
        appearance: none;
        border: 0px;
        outline: 0px;
        border-radius: 4.1rem;
        margin-top: 0rem;

        @media only screen and (max-width: 500px) {
          font-size: 1.6rem;
        }

        //         select#selectHospital option[value="1"]   { background-image:url(../assets/image/NewDesign/dropdown.png);   }
        // select#selectHospital option[value="2"] { background-image:url(../assets/image/NewDesign/dropdown.png); }
        // select#selectHospital option[value="4"] { background-image:url(../assets/image/NewDesign/dropdown.png); }
      }

      // .dropdown-arrow {
      //   height: 1rem;
      //   line-height: 4rem;
      //   margin-top: 1.5rem;
      //   margin-left: 1rem;
      // }
    }
  }
}

.search-box {
  margin-top: -7.5rem;
  display: flex;
  border: 2px solid #cceab5;
  border-radius: 9rem;
  width: 90%;
  height: 5rem;
  background: #ffffff;
  // background: transparent;

  input {
    height: 4rem;
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    border: none;
    padding: 1rem;
  }

  input:focus {
    outline: none;
    border: none;
  }

  // .search-btn {
  //   background: #2DC790;
  //   border: none;
  //   width: 3rem;
  //   height: 3rem;
  //   border-radius: 10rem;
  //   align-content: center;
  // }

  // .search-btn:hover {
  //   background: #2DC790;
  //   outline: none;
  //   border: none;
  // }
}

.filter-group {
  margin-top: 2rem;
  margin-bottom: 2rem;
  display: grid;
  gap: 1rem;
  grid-template-columns: 50% 45%;

  .filter-show-category {
    padding: 1rem;
    height: 48px;
    border-radius: 50px;
    border: #b2c1b2 1px solid;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;

    .show-category {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
    }
  }

  .filter-show-category-2 {
    display: inline-flex;
    padding: 1rem;
    height: 48px;
    border-radius: 50px;
    border: #b2c1b2 1px solid;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;

    .show-category-2 {
      display: inline-flex;
      white-space: nowrap;
      // overflow: hidden;
      // text-overflow: ellipsis;
      width: 100%;
      line-height: 24px;
    }
  }

  .filter-type {
    padding: 1rem;
    height: 48px;
    border-radius: 50px;
    border: #b2c1b2 1px solid;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    -webkit-appearance: none;
    color: #000000;
    background: #ffffff;
    background: transparent;
    background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACaSURBVHgB7ZHBDYMwDEW/UQfJKkzSrtBbb+XYW1dgE1bJJBg7IMQBIZwLHP6ToiRO4v/tAIQQQsjFSOTyp/snjHihQf/r3vns2RENIpiAQr46ylAEN+Ie87NiIsAjctmrg+JpIy0mWg/72qZk/cw2+kjK0Bc4pVo1QTNh27yEi7iItpH2VxnYMYFa8flpJasJT1IpTgghhNyCCWQHQ5Az6Q5MAAAAAElFTkSuQmCC")
      no-repeat 95% 50%;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
  }

  .filter-type:focus {
    outline: none;
  }
}

.package-card-container {
  display: block;
  padding-bottom: 3rem;

  .package-card-show {
    margin-top: 1rem;
    border-radius: 15px;
    border: #cceab5 1px solid;
    -webkit-appearance: none;
    box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
      5px 5px 10px rgba(163, 162, 162, 0.25);
    // border: 1px solid #fff;
    // border:solid 1rem #000;

    -webkit-box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
      5px 5px 10px rgba(163, 162, 162, 0.25);

    .content {
      width: 100%;
      object-fit: cover;

      .image {
        width: 100%;
        height: 14rem;
        border-radius: 15px 15px 0 0;
        object-fit: cover;
      }

      .text {
        padding: 1rem;

        .package-name {
          color: #474747;
          font-size: 16px;
          font-weight: 400;
          line-height: 25px;
          letter-spacing: 0em;
          text-align: left;
        }

        .box-below {
          display: inline-flex;
          justify-content: space-between;
          width: 100%;

          .package-price {
            width: 100%;
            display: inline-flex;
            // justify-content: space-between;

            .net-price {
              color: #ff3636;
              font-size: 18px;
              font-weight: 500;
              line-height: 46px;
              letter-spacing: 0em;
              text-align: left;
            }

            .net-price-2 {
              color: #000000;
              font-size: 18px;
              font-weight: 500;
              line-height: 46px;
              letter-spacing: 0em;
              text-align: left;
            }

            .list-price {
              color: #777e90;
              font-size: 12px;
              font-weight: 500;
              line-height: 46px;
              letter-spacing: 0em;
              text-align: left;
              text-decoration: line-through;
              margin-left: 1rem;
            }
          }

          .booking-button {
            margin: auto;
            border: none;
            background: #d2e97a;
            color: #000000;
            width: 10rem;
            font-size: 14px;
            font-weight: 500;
            letter-spacing: 0em;
            text-align: center;
            width: 102px;
            height: 46px;
            border-radius: 30px;
          }
        }
      }

      // -webkit-appearance: none;
      // -webkit-box-shadow: 3px 4px 7px rgba(165, 165, 165, 0.25);
    }
  }

  @media only screen and (min-width: 714px) {
    grid-template-columns: calc(33% - 0.8rem) calc(33% - 0.8rem);
  }
}

.filter-page {
  background: #ffffff;
  margin: auto;

  .filter-header {
    height: 5rem;

    background: #ffffff;
    color: #000000;
    // padding: 1.6rem 0;
    margin: 1.6rem 0;
    display: grid;
    grid-template-columns: 30% 40% 30%;
    gap: 0.4rem;

    .filter-close {
      border: none;
      box-shadow: 3px 4px 7px 0px #a5a5a540;
      border-radius: 4rem;
      width: 4rem;
      height: 4rem;
      padding: 1rem;
    }

    .header {
      font-size: 2rem;
      font-weight: 400;
      color: #000000;
      line-height: 2rem;
    }

    .filter-clear {
      font-size: 1.6rem;
      font-weight: 400;
      color: #ee2e2e;
      line-height: 3rem;
      text-decoration: underline;
      margin-right: 3rem;
      text-align: right;
      bottom: 0;
    }
  }

  .filter-part {
    .category-header {
      font-size: 1.8rem;
      font-weight: 400;
      color: #000000;
      line-height: 2rem;
      margin-bottom: 1rem;
    }

    .filter-category {
      padding: 1rem;
      height: 51px;
      width: 100%;
      border-radius: 15px;
      border: #b2c1b2 1px solid;
      background: #ffffff;
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: left;
      color: #000000;
      background: transparent;
      background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAICAYAAADJEc7MAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAA/SURBVHgBjc/LCQAwCAPQjJL9l+ooLRQP4oekUA+aJwgAJz6hH1P+l2tglmxr0ECUA2fxFJBow+79Dduo4hU9A+MnGZwWJUsAAAAASUVORK5CYII=")
        no-repeat 95% 50%;
      -moz-appearance: none;
      -webkit-appearance: none;
      appearance: none;
    }

    .filter-category:focus {
      outline: none;
    }
  }

  .filter-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 10rem;

    .filter-confirm {
      position: fixed;
      margin: auto;
      border: none;
      width: 70%;
      height: 5rem;
      border-radius: 31px;
      background: #d2e97a;
      color: #000000;
      font-size: 1.6rem;
      font-weight: 500;
    }
  }
}

.more-detail-footer {
  bottom: 0;
  position: fixed;
  // height: 50vh;
  width: 100%;
  z-index: 99;
  background: #ffffff;
  box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
    5px 5px 10px rgba(163, 162, 162, 0.25);
  padding: 1rem;
  padding-bottom: 3rem;

  .more-detail-box {
    margin: auto;
    margin-top: 2rem;
    width: 90%;

    .close {
      width: 2rem;
      height: 2rem;
    }

    .more-detail-header {
      display: grid;
      grid-template-columns: 30% 70%;
      gap: 1rem;

      .header-img {
        margin: auto;
        width: 6rem;
        height: 6rem;
        object-fit: cover;
        border-radius: 15px;
      }

      .header-text {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;

        .price {
          display: inline-flex;

          .net-price {
            color: #c31212;
            font-size: 1.6rem;
          }

          .net-price2 {
            color: #545454;
            font-size: 1.6rem;
          }

          .list-price {
            margin-left: 2rem;
            text-decoration: line-through;
            color: #545454;
            font-size: 1.2rem;
          }
        }
      }
    }

    .more-detail-item {
      max-height: 20rem;
      overflow: scroll;

      .more-detail-itemname {
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0em;
        color: #545454;
      }
    }

    .more-detail-description {
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      letter-spacing: 0em;
      // color: #545454;
      color: #c31212;

      .more-description {
        color: #c31212;
        font-size: 1.2rem;
        font-weight: 400;
        line-height: 15px;
        letter-spacing: 0em;
        margin-top: 1rem;
        margin-bottom: 1rem;
      }
    }

    .add-item-button {
      width: 90%;
      margin: auto;
      margin-top: 2rem;
      border-radius: 30px;
      background: #2dc790;
      outline: none;
      border: none;

      .add-item {
        font-size: 16px;
        font-weight: 500;
        line-height: 40px;
        letter-spacing: 0em;
        text-align: center;
        color: #ffffff;
      }
    }
  }

  .booking-button {
    border: none;
    background: #d2e97a;
    color: #000000;
    width: 100%;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0em;
    text-align: center;
    height: 46px;
    border-radius: 30px;
  }
}

.seperate-line {
  border: 0.5px solid #dbe7d4;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.package-header {
  font-size: 20px;
  font-weight: 500;
  line-height: 48px;
  letter-spacing: -0.01em;
  text-align: left;

  @media only screen and (max-width: 400px) {
    font-size: 18px;
  }
}
</style>
